import React, { useEffect } from 'react';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CourthouseSection from './components/CourthouseSection';
import ServicesSection from './components/ServicesSection';
import TeamSection from './components/TeamSection';
import SuccessRatesSection from './components/SuccessRatesSection';
import CitadelSection from './components/CitadelSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Add smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white text-[#1a1d2e]">
        <Header />
        <main>
          <HeroSection />
          <AboutSection />
          <CourthouseSection />
          <ServicesSection />
          <TeamSection />
          <SuccessRatesSection />
          <CitadelSection />
          <ContactSection />
        </main>
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
